"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _intents = require("@ux/intents");
var _intents2 = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
/* eslint-disable max-statements */

const styleProperties = [_intents.enums.properties.FONT_FAMILY, _intents.enums.properties.FONT_SIZE, _intents.enums.properties.FONT_WEIGHT, _intents.enums.properties.LINE_HEIGHT, _intents.enums.properties.FONT_VARIATION];

/**
 * This IIFE creates the Siteglass-specific component intents with fallback values.
 */
var _default = exports.default = function () {
  _intents2.default.create('@header/navigate/primary', {
    styleProperties
  });
  _intents2.default.headerNavigatePrimary.fontSize = `1rem`;
  _intents2.default.headerNavigatePrimary.fontWeight = `400`;
  _intents2.default.headerNavigatePrimary.lineHeight = `1.33`;
  _intents2.default.create('@header/navigate/primary/drop/down', {
    styleProperties
  });
  _intents2.default.headerNavigatePrimaryDropDown.fontSize = `1rem`;
  _intents2.default.headerNavigatePrimaryDropDown.fontWeight = `850`;
  _intents2.default.headerNavigatePrimaryDropDown.lineHeight = `1.5`;
  return _intents2.default;
}();